import axios from 'axios';
import createMetadataAPIOperations from '../../utils/api-metadata-operations';
import { API_PATH } from '../../../constants';
const options = {
  name: 'dutyExchanges',
  baseType: 'DUTY_EXCHANGES',
  apiEndpoint: 'duty_exchanges'
};
const apiOperations = createMetadataAPIOperations(options);

const createInverse = data => () => {
  const handleError = error => {
    const { response } = error;
    if (response.status === 422) {
      return response.data.validation_errors;
    }
  };
  const url = `${API_PATH}/${options.apiEndpoint}/${data.original_exchange_id}/inverse`;
  return axios
    .post(url, data)
    .then(response => response)
    .catch(handleError);
};

export const operations = {
  ...apiOperations,
  createInverse
};
